import type { SpartacuxShoppingCartState } from '../../ShoppingCartState';

export const selectCartOverview = (state: SpartacuxShoppingCartState) =>
  state.shoppingCart?.cartOverview;
